// Strokes with currentColor rather than the design's literal red, so a dismissed card's muted
// header colours the glyph along with its text.
export default function RxIcon({ width = 20, height = 20, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.417'>
        <path d='M3.626 3.69H5.48a1.562 1.562 0 0 1 0 3.124H3.626M3.626 3.69v5.95M4.999 6.815l4.057 4.047M9.056 7.626 5.82 10.862M14.025 10.671a2.776 2.776 0 0 1 3.925 3.925l-3.346 3.346a2.777 2.777 0 0 1-3.947-3.903zM12.509 12.188l3.925 3.925' />
        <path d='M8.609 17.109h-6.7a1.2 1.2 0 0 1-1.2-1.2v-14a1.2 1.2 0 0 1 1.2-1.2h9.103a1.2 1.2 0 0 1 .848.351l2.298 2.297a1.2 1.2 0 0 1 .35.849v3.702' />
        <path d='M10.87.708v3.703h3.633' />
      </g>
    </svg>
  );
}
